<template>
  <div class="product-card">
    <img :src="imageUrl" :alt="name" class="product-image" />
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    imageUrl: {
      type: String,
      required: true
    },
  }
}
</script>

<style scoped>
.product-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 500px; /* 桌面端默認寬度 */
  flex-shrink: 0; /* 防止卡片在 flex 容器中被壓縮 */
  padding: 10px; /* 給卡片自身一些內邊距，避免圖片直接貼邊 */
  box-sizing: border-box;
  cursor: pointer; /* 暗示可點擊 */
}

.product-image {
  width: 100%;
  height: 500px; /* 桌面端默認高度 */
  object-fit: cover;
  border-radius: 8px; /* 稍微增加圓角 */
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* 稍微加深陰影 */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* 添加陰影過渡 */
}

.product-image:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}


/* 響應式調整 */
@media (max-width: 1200px) {
  .product-card {
    width: 400px;
  }
  .product-image {
    height: 400px;
  }
  /*
  .product-name {
    font-size: 26px;
  }
  */
}

@media (max-width: 992px) {
  .product-card {
    width: 320px;
  }
  .product-image {
    height: 320px;
  }
  /*
  .product-name {
    font-size: 22px;
  }
  */
}

@media (max-width: 768px) {
  .product-card {
    width: 280px; /* 在手機上可以更小一些 */
    padding: 8px;
  }
  .product-image {
    height: 280px;
    margin-bottom: 10px;
  }
  /*
  .product-name {
    font-size: 18px;
  }
  */
}

@media (max-width: 576px) {
  .product-card {
    width: 220px; /* 如果父組件的 scale(0.75) 在移動端移除，這個寬度會更合適 */
                  /* 如果父組件的 scale(0.75) 依然存在，那麼視覺寬度會是 220*0.75 = 165px */
  }
  .product-image {
    height: 220px;
  }
  /*
  .product-name {
    font-size: 16px;
  }
  */
}
</style>